import { Text } from "react-native-paper";
import { View } from "react-native";

import { Employment } from "../types";
import EmploymentMenu from "../../components/NavMenu";
import { useNavigation } from "@react-navigation/native";
import { useFeatureFlags } from "../../hooks/useFlagr";

const EmploymentSection = ({ employment, memberClass }: { employment: Employment; memberClass?: string }) => {
  const navigation = useNavigation();
  const flags = useFeatureFlags();

  function navigateToEmploymentRemove() {
    navigation.navigate("EmploymentRemove", { id: employment.id });
  }

  return (
    <View className="mt-4 rounded-lg border border-sky bg-sky-white flex p-6">
      <View className="flex-row justify-between items-center">
        <View>
          <Text className="text-small-tight font-400 text-ink-dark">{`${
            employment.isPrimary ? "Primary" : "Secondary"
          } Facility`}</Text>
          <Text className="text-regular-tight font-700 text-ink-darkest mt-1">{employment.facility.name}</Text>
        </View>
        {flags["membership-add-employment"] ? (
          <EmploymentMenu items={[{ title: "Remove Employment", icon: "trash", onPress: navigateToEmploymentRemove }]} />
        ) : null}
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">Job Title</Text>
        {employment.title && (
          <Text className="text-regular-tight font-400 text-ink-darkest mt-1">{employment.title ?? "None"}</Text>
        )}
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">Classification</Text>
        <Text className="text-regular-tight font-400 text-ink-darkest mt-1">{memberClass ?? "None"}</Text>
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">State/Province</Text>
        <Text className="text-regular-tight font-400 text-ink-darkest mt-1">
          {employment.facility.addresses[0]?.state ?? "None"}
        </Text>
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">Section</Text>
        <Text className="text-regular-tight font-400 text-ink-darkest mt-1">{employment.facility.section?.name ?? "None"}</Text>
      </View>
    </View>
  );
};

export default EmploymentSection;
